import { bindUrl, request } from "./request";
/**
 * 开户行列表
 * GET /oil/client/bank/code/list
 * @param {Object} queryParams
 * @param {number} queryParams.type - 类型 1: 企业银行卡 2: 个人银行卡
 */
export function getCodeList(queryParams) {
  return request({
    url: bindUrl("/oil/app/client/bank/code/list", {}),
    method: "GET",
    params: queryParams
  });
}
/**
 * 银行卡新增
 * POST /oil/client/bank/create
 * @param {银行卡新增} bodyParams - clientBankCreateReq
 */
export function createBankCard(bodyParams) {
  return request({
    url: bindUrl("/oil/app/client/bank/create", {}),
    method: "POST",
    data: bodyParams
  });
}
/**
 * 银行卡详情
 * GET /oil/client/bank/detail
 * @param {Object} queryParams
 * @param {number} queryParams.id - 银行卡id
 */
export function getBankCardDetail(queryParams) {
  return request({
    url: bindUrl("/oil/app/client/bank/detail", {}),
    method: "GET",
    params: queryParams
  });
}
/**
 * 银行卡编辑
 * POST /oil/client/bank/edit
 * @param {ClientBankEditReq} bodyParams - clientBankEditReq
 */
export function editBankCard(bodyParams) {
  return request({
    url: bindUrl("/oil/app/client/bank/edit", {}),
    method: "POST",
    data: bodyParams
  });
}
/**
 * 银行卡列表
 * GET /oil/client/bank/list
 * @param {Object} queryParams
 * @param {number} queryParams.clientId - 客户id
 */
export function getBankCardList(bodyParams) {
  return request({
    // url: bindUrl("/oil/app/client/bank/list", {}),
    url: bindUrl("/svc-lss/bank/personal/account/list", {}),
    method: "POST",
    data: bodyParams
  });
}

export function personalComplete(bodyParams) {
  return request({
    url: bindUrl("/svc-lss/shb/personal/info/complete", {}),
    method: "POST",
    data: bodyParams
  });
}

export function getCode(bodyParams) {
  return request({
    url: bindUrl("/svc-lss/shb/personal/account/code/fetch", {}),
    method: "POST",
    data: bodyParams
  });
}

export function codeVerify(bodyParams) {
  return request({
    url: bindUrl("/svc-lss/shb/personal/account/code/verify", {}),
    method: "POST",
    data: bodyParams
  });
}

export function accountCreate(bodyParams) {
  return request({
    url: bindUrl("/svc-lss/shb/personal/account/reCreate", {}),
    method: "POST",
    data: bodyParams
  });
}

export function getAccountDetail(queryParams) {
  return request({
    url: bindUrl("/svc-lss/bank/account/detail", {}),
    method: "GET",
    params: queryParams
  });
}

export function withdrawCodeFetch(bodyParams) {
  return request({
    url: bindUrl("/svc-lss/shb/personal/withdraw/code/fetch", {}),
    method: "POST",
    data: bodyParams
  });
}

export function withdrawApply(bodyParams) {
  return request({
    url: bindUrl("/svc-lss/shb/withdraw/apply", {}),
    method: "POST",
    data: bodyParams
  });
}

export function withdrawCodeVerify(bodyParams) {
  return request({
    url: bindUrl("/svc-lss/shb/withdraw/code/verify", {}),
    method: "POST",
    data: bodyParams
  });
}

/**获取银行列表**/
export function getBankList(queryParams) {
  return request({
    url: bindUrl("/oil/app/bank/list", {}),
    method: "GET",
    params: queryParams
  });
}
/**获取支行列表**/
export function getContactsBankList(queryParams) {
  return request({
    url: bindUrl("/oil/app/bank/contacts/list", {}),
    method: "GET",
    params: queryParams
  });
}
/**获取省编码**/
export function getProvinceCode(queryParams) {
  return request({
    url: bindUrl("/oil/app/bank/provinceCode/list", {}),
    method: "GET",
    params: queryParams
  });
}
/**获取市编码**/
export function getCityCode(queryParams) {
  return request({
    url: bindUrl("/oil/app/bank/cityCode/list", {}),
    method: "GET",
    params: queryParams
  });
}
/**获取区编码**/
export function getAreaCode(queryParams) {
  return request({
    url: bindUrl("/oil/app/bank/areaCode/list", {}),
    method: "GET",
    params: queryParams
  });
}
/**银行卡激活验证码获取**/
export function getBindCode(queryParams) {
  return request({
    url: bindUrl("/oil/app/client/bank/bind/code", {}),
    method: "POST",
    data: queryParams
  });
}
/**个人银行卡验证提交**/
export function bankBindActive(queryParams) {
  return request({
    url: bindUrl("/oil/app/client/bank/bind/active", {}),
    method: "POST",
    data: queryParams
  });
}
/**银行卡解绑证码获取**/
export function getUnBindCode(queryParams) {
  return request({
    url: bindUrl("/oil/app/client/bank/unBind/code", {}),
    method: "POST",
    data: queryParams
  });
}
/**银行卡解绑确认**/
export function unBindConfirm(queryParams) {
  return request({
    url: bindUrl("/oil/app/client/bank/unBind/confirm", {}),
    method: "POST",
    data: queryParams
  });
}
/**客户获取激活的银行卡列表**/
export function bankActiveList(queryParams) {
  return request({
    url: bindUrl("/oil/app/client/bank/activeList", {}),
    method: "GET",
    params: queryParams
  });
}

/**交易员获取激活的银行卡列表**/
export function adminBankActiveList(queryParams) {
  return request({
    url: bindUrl("/oil/admin/client/bank/activeList", {}),
    method: "GET",
    params: queryParams
  });
}

export function creatBankCard(queryParams) {
  return request({
    url: bindUrl("/svc-lss/bank/personal/create", {}),
    method: "POST",
    data: queryParams
  });
}

export function approveInfo(queryParams) {
  return request({
    url: bindUrl("/blade-user/approve/approveInfo", {}),
    method: "GET",
    params: queryParams
  });
}

export function accountVerify(queryParams) {
  return request({
    url: bindUrl("/svc-lss/shb/company/account/verify", {}),
    method: "POST",
    data: queryParams
  });
}
